module.exports = __webpack_public_path__ + "static/media/evolveLogoPngWords.5689d919.png";